"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useOnClickOutside(ref, handler) {
    (0, react_1.useEffect)(() => {
        const listener = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener("mouseup", listener);
        document.addEventListener("touchend", listener);
        return () => {
            document.removeEventListener("mouseup", listener);
            document.removeEventListener("touchend", listener);
        };
    }, 
    // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [ref, handler]);
}
exports.default = useOnClickOutside;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlT25DbGlja091dHNpZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2hvb2tzL3VzZU9uQ2xpY2tPdXRzaWRlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaUNBQTZDO0FBSTdDLFNBQXdCLGlCQUFpQixDQUN2QyxHQUF1QixFQUN2QixPQUErQjtJQUUvQixJQUFBLGlCQUFTLEVBQ1AsR0FBRyxFQUFFO1FBQ0gsTUFBTSxRQUFRLEdBQUcsQ0FBQyxLQUFpQixFQUFFLEVBQUU7WUFDckMsOERBQThEO1lBQzlELElBQUksQ0FBQyxHQUFHLENBQUMsT0FBTyxJQUFJLEdBQUcsQ0FBQyxPQUFPLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxNQUFjLENBQUMsRUFBRTtnQkFDOUQsT0FBTzthQUNSO1lBRUQsT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDO1FBQ2pCLENBQUMsQ0FBQztRQUVGLFFBQVEsQ0FBQyxnQkFBZ0IsQ0FBQyxTQUFTLEVBQUUsUUFBUSxDQUFDLENBQUM7UUFDL0MsUUFBUSxDQUFDLGdCQUFnQixDQUFDLFVBQVUsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUVoRCxPQUFPLEdBQUcsRUFBRTtZQUNWLFFBQVEsQ0FBQyxtQkFBbUIsQ0FBQyxTQUFTLEVBQUUsUUFBUSxDQUFDLENBQUM7WUFDbEQsUUFBUSxDQUFDLG1CQUFtQixDQUFDLFVBQVUsRUFBRSxRQUFRLENBQUMsQ0FBQztRQUNyRCxDQUFDLENBQUM7SUFDSixDQUFDO0lBQ0QsNkNBQTZDO0lBQzdDLGdFQUFnRTtJQUNoRSwrREFBK0Q7SUFDL0Qsb0VBQW9FO0lBQ3BFLHFFQUFxRTtJQUNyRSxpQ0FBaUM7SUFDakMsQ0FBQyxHQUFHLEVBQUUsT0FBTyxDQUFDLENBQ2YsQ0FBQztBQUNKLENBQUM7QUEvQkQsb0NBK0JDIn0=